import { c as _c } from "react/compiler-runtime";
export const ChatKitStarIcon = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.26232 10.2801L7.02348 9.34615C7.54056 9.05629 7.96644 8.60541 8.24017 8.05793L9.11922 6.19323C9.2409 5.93559 9.60589 5.93559 9.72757 6.19323L10.6097 8.05793C10.8834 8.60541 11.3093 9.05629 11.8233 9.34615L13.5875 10.2801C13.8308 10.4089 13.8308 10.7922 13.5875 10.921L11.8233 11.8549C11.3093 12.1448 10.8834 12.5957 10.6097 13.1432L9.72757 15.0078C9.60589 15.2655 9.2409 15.2655 9.11922 15.0078L8.24017 13.1432C7.96644 12.5957 7.54056 12.1448 7.02348 11.8549L5.26232 10.921C5.01901 10.7922 5.01901 10.4411 5.26232 10.2801Z" fill="white" />;
    t1 = <path d="M34.4866 19.4836L30.4137 21.6381C29.2001 22.2822 28.1964 23.3418 27.588 24.63L25.5531 28.9423C25.2489 29.551 24.4276 29.551 24.1235 28.9423L22.0886 24.63C21.4802 23.3418 20.4795 22.2822 19.2628 21.6381L15.193 19.4836C14.5847 19.1615 14.5847 18.2598 15.1626 17.9699L19.2628 15.8154C20.4795 15.1713 21.4802 14.1085 22.0886 12.8235L24.1235 8.5112C24.4276 7.90252 25.2489 7.90252 25.5531 8.5112L27.588 12.8235C28.1964 14.1085 29.2001 15.1713 30.4137 15.8154L34.4866 17.9699C35.0645 18.292 35.0645 19.1615 34.4866 19.4836Z" fill="white" />;
    t2 = <path d="M16.2111 29.7198L14.4468 30.6538C13.9328 30.9436 13.5069 31.3945 13.2332 31.942L12.3511 33.8067C12.2294 34.0643 11.8644 34.0643 11.7428 33.8067L10.8637 31.942C10.59 31.3945 10.1641 30.9436 9.64702 30.6538L7.88585 29.7198C7.64254 29.591 7.64254 29.2399 7.88585 29.0789L9.64702 28.145C10.1641 27.8551 10.59 27.4042 10.8637 26.8568L11.7428 24.9921C11.8644 24.7344 12.2294 24.7344 12.3511 24.9921L13.2332 26.8568C13.5069 27.4042 13.9328 27.8551 14.4468 28.145L16.2111 29.0789C16.4544 29.2078 16.4544 29.591 16.2111 29.7198Z" fill="white" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};